import { FISCAL_ENVIRONMENT_LABEL, type FiscalEnvironment } from '@optefiscal/fiscal-domain';

/**
 * Selo de ambiente fiscal.
 *
 * Plano Oficial, seção 6.3: "UI deve tornar o ambiente visível em toda operação
 * sensível." Nunca há valor padrão: o ambiente é sempre recebido, nunca
 * assumido.
 *
 * Homologação recebe a cor de atenção porque confundir ambiente foi um dos
 * incidentes históricos que o 2.0 nasce para impedir.
 */
export function EnvironmentBadge({ environment }: { environment: FiscalEnvironment }) {
  return (
    <span className={`of-env of-env--${environment}`}>
      <span className="of-env__dot" aria-hidden />
      <span>Ambiente: {FISCAL_ENVIRONMENT_LABEL[environment]}</span>
    </span>
  );
}
